import script from "./StartArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./StartArrow.vue?vue&type=script&setup=true&lang=js"

import "./StartArrow.vue?vue&type=style&index=0&id=69c862da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c862da"]])

export default __exports__